<template>
    <div class="home">
        <!-- <PhotoFrame src="http://127.0.0.1:3000/static/cover/20240224/1920x1080.jpg" /> -->
        <template v-if="photoAlbumData.length">
            <PhotoAlbum ref="photoAlbum" :data="photoAlbumData" />
        </template>
        <template v-else>
            <p>正在加载...</p>
        </template>
        <CopyRight :class="{ hidden: hiddenCopyRight }" />
        <ToTop @toTop="toTop" :show="showToTop" />
    </div>
</template>

<script lang="ts" setup>
import { Ref, getCurrentInstance, onBeforeUnmount, onMounted, ref } from "vue";
import PhotoAlbum from "@/components/PhotoAlbum.vue";
import { formatDate } from "@/utils/date";
import type { IPhoto } from "@/types/photo";
import CopyRight from "@/components/CopyRight.vue";
import ToTop from "@/components/ToTop.vue";

const baseUrl = process.env.VUE_APP_BASE_URL;

const instance = getCurrentInstance()?.proxy;

const photoAlbum: Ref<{ getBounds: () => Record<string, number> } | null> = ref(null);
const today = new Date();
const step = 9;
const total = 366;
let photoAlbumData: Ref<Array<IPhoto>> = ref([]) as Ref<Array<IPhoto>>;
let loadingPhoto = false;
let hiddenCopyRight = false;
let showToTop = false;

function getBounds() {
    const rect = instance?.$el.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom,
    };
}

async function getPhotos() {
    if (loadingPhoto) {
        return;
    }
    loadingPhoto = true;
    const length = photoAlbumData.value.length;
    for (let i = 0; i < step; i++) {
        const date = formatDate(new Date(today.getTime() - 86400000 * (i + length)), "yyyy-MM-dd");
        await fetch(`${baseUrl}/api/cover/${date}`)
            .then((res) => res.json())
            .then((res) => {
                const data = res.data || [];
                data.forEach((item: { url: string; desc: string }) => {
                    photoAlbumData.value.push({
                        src: `${baseUrl}/${item.url}`,
                        alt: date,
                        title: item.desc,
                    });
                });
            })
            .catch((err) => {
                console.error(err);
                photoAlbumData.value.push({
                    src: "",
                    alt: date,
                    title: "加载失败",
                });
            });
    }
    loadingPhoto = false;
}

function handleScroll() {
    hiddenCopyRight = false;
    let photoAlbumRect = photoAlbum.value?.getBounds();
    const instanceRect = getBounds();
    let flag = photoAlbumData.value.length < total;
    if (photoAlbumRect && flag) {
        if (photoAlbumRect.bottom < instanceRect.bottom + 20) {
            // flag = false;
            getPhotos();
        }
    } else if (flag) {
        getPhotos();
    }
    if (window.scrollY > 1000) {
        showToTop = true;
    } else {
        showToTop = false;
    }
}

function toTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
}

onMounted(() => {
    getPhotos().then(() => {
        handleScroll();
    });
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
});

onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("resize", handleScroll);
});
</script>
<style lang="scss" scoped>
.home {
    position: relative;
    background-color: #f5f5f5;
    box-sizing: border-box;
    padding-bottom: 42px;
    .copy-right {
        position: fixed;
        bottom: 0;
        border-top: 1px solid #d7d7d7;
        transition: bottom 0.5s ease-in-out;
        &.hidden {
            bottom: -100px;
        }
    }
}
</style>
